export const DefaultLang = 'fa'